/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


(function() {

  function wrapSyracuse() {
    // Sélectionner tous les hero titles ET product titles
    const titles = document.querySelectorAll('.hero__title, .product__title');

    titles.forEach(title => {
      // On évite de le refaire si déjà traité
      if (!title.dataset.syracuseWrapped) {
        title.innerHTML = title.innerHTML.replace(
          /\bSyracuse\b/gi,
          '<span class="font-bonhomme">Syracuse</span>'
        );
        title.dataset.syracuseWrapped = true;
      }
    });
  }

  // Exécution au chargement de la page
  document.addEventListener("DOMContentLoaded", wrapSyracuse);
  // Exécution quand Shopify recharge une section
  document.addEventListener("shopify:section:load", wrapSyracuse);

})();

// ===== COLLE ICI LE NOUVEAU BLOC =====
// Masquer le bloc "Pierres de pavage" si le champ "Type" est vide
(function() {

  function hidePaveIfEmpty() {
    document.querySelectorAll('.drawer__body h5').forEach(function (title) {
      if (title.dataset.paveChecked) return;

      var label = title.textContent.replace(/\u00a0/g, ' ').trim().toLowerCase();
      if (label !== 'pierres de pavage') return;

      var para = title.nextElementSibling;
      if (!para || para.tagName !== 'P') return;

      title.dataset.paveChecked = 'true';

      // Première ligne du <p> = "Type : ..."
      var firstLine = para.innerHTML.split(/<br\s*\/?>/i)[0];
      var tmp = document.createElement('div');
      tmp.innerHTML = firstLine;
      var text = tmp.textContent.replace(/\u00a0/g, ' ').trim();
      var value = text.split(':').slice(1).join(':').trim();

      if (value === '') {
        title.style.display = 'none';
        para.style.display = 'none';
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    hidePaveIfEmpty();
    new MutationObserver(hidePaveIfEmpty).observe(document.body, {
      childList: true,
      subtree: true
    });
  });
  document.addEventListener("shopify:section:load", hidePaveIfEmpty);

})();
// ===== FIN DU NOUVEAU BLOC =====


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();